import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@morpho-org/ui-v6/server';
export interface DashboardBorrowPositionsTableRowsSkeletonProps {
  rows: number;
}

// One placeholder per MobileMarketPositionCard as the owner sees it (367px, with actions).
const DashboardBorrowPositionsTableRowsSkeleton = t0 => {
  const $ = _c(2);
  const {
    rows
  } = t0;
  let t1;
  if ($[0] !== rows) {
    t1 = <div className="gap-sm flex w-full flex-col">{Array.from({
        length: rows
      }).map(_temp)}</div>;
    $[0] = rows;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default DashboardBorrowPositionsTableRowsSkeleton;
function _temp(_, index) {
  return <Skeleton key={index} className="h-[367px] w-full rounded-[20px]" />;
}